export default "__VITE_ASSET__BprFwXGy__"